import { render, staticRenderFns } from "./AdminConfigDeptStatistic.vue?vue&type=template&id=6c5a675a&scoped=true&"
import script from "./AdminConfigDeptStatistic.vue?vue&type=script&lang=js&"
export * from "./AdminConfigDeptStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AdminConfigDeptStatistic.vue?vue&type=style&index=0&id=6c5a675a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a675a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VDivider,VIcon,VList,VListItem})
